<template>
  <img
    @error="onError"
    class="app-image"
    :loading="lazyLoading ? 'lazy' : undefined"
    :class="{
      avatar,
      contain,
      cover,
      square,
    }"
    v-bind="$attrs"
    :src="currentImage"
    :width="width"
    :height="height"
    :style="{
      width: width ? `${width}px` : undefined,
      height: height ? `${height}px` : undefined,
      'background-color': backgroundColor,
      border,
      'border-radius': borderRadius,
    }"
  />
</template>

<script>
export default {
  name: 'AppImage',
  inheritAttrs: false,

  data() {
    return {
      timer: 0,
      currentImageIndex: 0,
      sourceIndex: 0,
    }
  },

  props: {
    lazyLoading: {
      type: Boolean,
      default: false,
    },

    avatar: {
      type: Boolean,
      default: false,
    },

    square: {
      type: Boolean,
      default: false,
    },

    backgroundColor: {
      type: String,
      required: false,
    },

    borderRadius: {
      type: String,
      required: false,
    },

    border: {
      type: String,
      required: false,
    },

    size: {
      type: String,
      required: false,
    },

    cover: {
      type: Boolean,
      required: false,
    },

    contain: {
      type: Boolean,
      required: false,
    },

    changeDelay: {
      type: Number,
      default: 5000,
    },

    sources: {
      type: Array,
      default: () => [],
      required: false,
    },
  },

  computed: {
    images() {
      let images = this.$attrs.src

      if (typeof images === 'string') images = [images]

      return images
    },

    currentImage() {
      const { sources, sourceIndex, images, currentImageIndex } = this

      return sources?.[sourceIndex]?.srcset ?? images?.[currentImageIndex]
    },

    width() {
      return parseFloat(this.size || this.$attrs.width) || undefined
    },

    height() {
      return parseFloat(this.size || this.$attrs.height) || undefined
    },
  },

  watch: {
    images: {
      immediate: true,
      handler: 'startTimer',
    },
  },

  destroyed() {
    this.stopTimer()
  },

  methods: {
    onError() {
      this.sourceIndex++
    },

    stopTimer() {
      if (this.timer) clearTimeout(this.timer)
    },

    startTimer() {
      this.stopTimer()

      const images = this.images ?? []

      if (images.length > 1)
        this.timer = setTimeout(
          () => this.nextImage().finally(this.startTimer),
          this.changeDelay,
        )
    },

    async nextImage() {
      let nextIndex = this.currentImageIndex + 1

      if (nextIndex >= this.images.length) nextIndex = 0

      this.currentImageIndex = nextIndex
    },
  },
}
</script>

<style lang="scss" scoped>
.app-image {
  &.avatar {
    $size: 48px;
    width: $size;
    height: $size;
    border-radius: 50%;
    object-fit: cover;
  }

  &.square {
    border-radius: 25%;
  }

  &.contain {
    object-fit: contain;
  }

  &.cover {
    object-fit: cover;
  }
}
</style>
